export default __webpack_public_path__ + "cb823b1679b84ab93d27a5ecd6abb4be.png";